import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphBuildState } from "../rewardGraphBuildState";
/**
 * Block used to apply a cross product between 2 vectors
 */
export class RewardMetricsProbeBlock extends RewardGraphNode {
    _metricName : string;

    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this._metricName = "metric_" + this.uniqueId.toFixed(0);
        this.registerInput("input", RewardGraphConnectionPointTypes.Float);
        this.registerOutput("output", RewardGraphConnectionPointTypes.Float);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardMetricsProbeBlock";
    }

    public get metricName() {
        return this._metricName;
    }

    public set metricName(n:string) {
        this._metricName = n;
    }

    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    public get input(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    protected override _buildBlock() {
        if (!this.input.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state : RewardGraphBuildState) => {
            const val = this.input.getConnectedValue(state);
            state.queryContext?.setMetric( this._metricName, val );
            return val;
        };
    }

    protected override _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.metricName = ${this.metricName};\n`;
        return codeString;
    }

    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */
    public override serialize(): any {
        const serializationObject = super.serialize();
        serializationObject.metricName = this.metricName;

        return serializationObject;
    }

    public override _deserialize(serializationObject: any) {
        super._deserialize(serializationObject);
        this.metricName = serializationObject.metricName;
    }
}

RegisterClass("MELS.RewardMetricsProbeBlock", RewardMetricsProbeBlock);
